import { useState, useEffect } from 'react';
import { useAPI } from 'components/lib';

export function useLogs() {

    const [state, setState] = useState({ data: null, loading: false });
    const logs = useAPI('/api/log?search=&offset=0&limit=100');

    useEffect(() => {

        setState({ loading: true });

        const log = logs.data?.results.reduce((acc, logData) => {
            if (!acc.some(item => item.label === logData.method)) {
                acc.push({ value: logData._id, label: logData.method });
            }
            return acc;
        }, []) || [];

        setState({ data: { list: log }, loading: false });

    }, [logs]);

    return state;

}